import { useEffect } from 'react'
import FaqsHelpHeader from './FaqsHelpHeader'
import {
	FAQAccordion, FAQContainer, FAQHeader
} from './FAQHelpStyles'
import FAQGeneral from './Faqs Sections/FAQGeneral'
import FAQMembership from './Faqs Sections/FAQMembership'
import FAQLineup from './Faqs Sections/FAQLineup'
import { handleGA4PageHit } from '../../Global/GA4Functions'

const FAQs = () => {
	useEffect(() => {
		document.title = "FAQs | TitanTV";
		document.querySelector('meta[name="description"]')?.setAttribute('content', "A collection of the most frequently asked questions about TitanTV.com and their answers.");
		document.querySelector('meta[name="robots"]')?.setAttribute('content', "index");
		window.scrollTo(0, 0);
		handleGA4PageHit({ page: '/faqs', title: 'FAQs' });
	})

	return (
		<>
			<FaqsHelpHeader />
			<FAQContainer>
				<FAQHeader>
					Frequently Asked Questions
				</FAQHeader>
				<FAQAccordion>
					<FAQGeneral />
					<FAQMembership />
					<FAQLineup />
				</FAQAccordion>
			</FAQContainer>
		</>
	)
}

export default FAQs